export const RESET = 'reset';
export const PRISMICDATA = 'prismic-data';
export const ISEXCLUSIVE = 'isExclusive';
